import { render, staticRenderFns } from "./Contas.vue?vue&type=template&id=2659772f&scoped=true"
import script from "./Contas.vue?vue&type=script&lang=js"
export * from "./Contas.vue?vue&type=script&lang=js"
import style0 from "./Contas.vue?vue&type=style&index=0&id=2659772f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2659772f",
  null
  
)

export default component.exports